<template>
  <el-container style="min-height: 100vh;">
    <el-aside
      v-show="layout.aside"
      :class="layout.navCollapsed ? 'collapsed' : 'expanded'"
    >
      <vs-aside/>
    </el-aside>

    <el-container style="width: 0;">
      <el-header
        v-show="layout.header"
        class="navigation"
      >
        <vs-navigation/>
      </el-header>


      <el-main v-loading="!isAccountReady">
        <router-view v-if="isAccountReady"/>
      </el-main>

    </el-container>

    <!-- Additional Plugin's components -->
    <SupportDialogue/>
  </el-container>
</template>

<script>
import Navigation from '@/components/Navigation';
import Aside from '@/components/Aside';
// Utilities
import SupportDialogue from '@/components/Utilities/Dialogue/SupportNew';
import navGuard from '@/utils/navGuard';
import createWatcher from '@/libs/onlineWatcher';
import NOTIFY_CONSTANTS from '@/config/notify-constants';
import '@/components/Shared';
// Element UI
import '@/utils/elementUiImporter';

export default {
  name: 'app',
  components: {
    'vs-navigation': Navigation,
    'vs-aside': Aside,
    SupportDialogue,
  },
  data() {
    return {
      isAccountReady: false,
      createWatcherInstance: null,
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.account.isAuthenticated;
    },
    isAccountReadyState() {
      return this.isAuthenticated !== null && this.$store.state.account.needSignup !== null;
    },
    layout() {
      return this.$store.state.layout;
    },
  },
  watch: {
    isAuthenticated(status) {
      if (status === false) {
        // Sync login router with account state
        navGuard(this.$route, (path) => {
          if (path != null) this.$router.push(path);
        }, 'app.vue');
      }
    },
  },
  mounted() {
    let offlineWatcherNotification = null;
    this.createWatcherInstance = createWatcher({
      onOffline: () => {
        offlineWatcherNotification = this.$notify.warning({
          title: 'No Internet',
          message: 'Seems like you\'re offline, please check your internet connection',
          showClose: false,
          duration: NOTIFY_CONSTANTS.DURATION.FOREVER,
        });
      },
      onOnline: () => {
        if (offlineWatcherNotification) offlineWatcherNotification.close();
        offlineWatcherNotification = null;
      },
    });

    // Warn closing of tab if an uploading is still on going
    window.addEventListener('beforeunload', (e) => {
      const uploadInProgress = this.$store.state.uploadQueue.activeCounter > 0;

      if (uploadInProgress) {
        e.returnValue = true;
        return true;
      }
      return null;
    });
    // TODO: Urgent! setTimeout is not deterministic and is hardware dependent.
    //       Need to find a way to resolve this problem.
    //       It appear that Store updates is faster than route changing.
    //       It is possible that this.$route is still pointing to the base '/' route
    //       causing navguard to navigation to '/'.
    let counter = 0;
    const interval = setInterval(() => {
      if (this.isAccountReadyState) {
        counter += 1;
        if (this.$route.path !== '/') {
          clearInterval(interval);
          this.isAccountReady = true;
          // Sync login router with account state
          navGuard(this.$route, (path) => {
            if (path != null) this.$router.push(path);
          }, 'app.vue');
        } else if (counter > 6000) {
          clearInterval(interval);
          this.isAccountReady = true;
          throw new Error('unable to resolve route in time');
        }
      }
    }, 10);
  },


};
</script>

<style lang="scss">
@import './assets/styles/style';
</style>



// WEBPACK FOOTER //
// src/App.vue